/**
 * Imagem e PDF numa conversa de WhatsApp: o que entra e com que nome.
 *
 * O balde `mensagens` (migração `0074`) aceita o mesmo — a tela recusa antes
 * para a pessoa saber na hora, e não depois de esperar o envio.
 */

export const TIPOS_DE_ARQUIVO_ACEITOS = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'] as const;
export const LIMITE_DO_ARQUIVO_BYTES = 16 * 1024 * 1024;

export function problemaDoArquivo(arquivo: { name: string; type: string; size: number }): string | null {
    if (!(TIPOS_DE_ARQUIVO_ACEITOS as readonly string[]).includes(arquivo.type)) {
        return `${arquivo.name} não pode ser enviado: o WhatsApp da clínica aceita imagem (JPG, PNG, WEBP) e PDF.`;
    }
    if (arquivo.size > LIMITE_DO_ARQUIVO_BYTES) return `${arquivo.name} passa de 16 MB.`;
    if (arquivo.size === 0) return `${arquivo.name} está vazio.`;
    return null;
}

export function tipoDaMensagemDoArquivo(tipoMime: string): 'imagem' | 'documento' {
    return tipoMime === 'application/pdf' ? 'documento' : 'imagem';
}

/** Nome que serve de caminho no balde: sem barra, sem espaço, sem acento que o storage recuse. */
export function nomeSeguroDoArquivo(nome: string): string {
    const limpo = nome
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^A-Za-z0-9._-]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    return limpo.slice(-80) || 'arquivo';
}
